const telefono = "5492364677163";
const whatsapp = "https://api.whatsapp.com/send?phone=" + telefono;
const instagram = "https://www.instagram.com/masajes.junin.sergio/";
const direccion = "Int. Cichero 44, Junín, Buenos Aires, Argentina";

export { telefono, whatsapp, instagram, direccion };
